<xemex-page-header [title]="'sidebarMenu.partnerships' | translate" [breadcrumbs]="breadcrumbs">
  @if (canManage()) {
    <xemex-filled-button actions type="button" icon="add" (click)="openCreateDialog()">
      {{ 'partnerships.create.title' | translate }}
    </xemex-filled-button>
  }
</xemex-page-header>

<xemex-page-body>
  <xemex-table
    [data]="tableData()"
    [columns]="columns"
    [loading]="partnershipStore.isLoading()"
    [totalCount]="totalCount()"
    [rowLink]="rowLink"
    (pageChange)="onPageChange($event)"
  ></xemex-table>
</xemex-page-body>
